import { OAuthToken } from '../entities';

const OAUTH_TOKEN_KEY = 'oauthToken';
const PLAYER_ID = 'playerId';

export const getBearerToken = () => {
  try {
    const oauthToken: OAuthToken = JSON.parse(localStorage.getItem(OAUTH_TOKEN_KEY));
    return oauthToken.expires_on > new Date().getTime()
      ? `Bearer ${oauthToken.access_token}`
      : '';
  } catch (_) {
    return '';
  }
};

export const setBearerToken = (token: OAuthToken): void => {
  const now = new Date().getTime();
  const expires_on = new Date(now + token.expires_in * 1000).getTime();
  localStorage.setItem(OAUTH_TOKEN_KEY, JSON.stringify({ ...token, expires_on }));
};

export const removeBearerToken = (): void => {
  localStorage.removeItem(PLAYER_ID);
  localStorage.removeItem(OAUTH_TOKEN_KEY);
};
